import Vue from 'vue'
import VueLodash from 'vue-lodash'
import lodash from 'lodash'

import App from './App.vue'
import router from './router'
import store from './store'
import VueAxios from 'vue-axios'
import axios from './axios'
import * as Sentry from '@sentry/browser'
import * as Integrations from '@sentry/integrations'
import '@mdi/font/css/materialdesignicons.css'
import VueYouTubeEmbed from 'vue-youtube-embed'
import YmapPlugin from 'vue-yandex-maps'
import VueLogger from 'vuejs-logger'
import user from '@/mixins/user'
import vuetify from '@/plugins/vuetify'

import VueLocalStorage from 'vue-localstorage'
import snackbar from '@/mixins/snackbar'

const moment = require('moment')
require('moment/locale/ru')

Vue.use(require('vue-moment'), {
  moment,
})

Vue.use(VueLodash, { name: 'custom', lodash: lodash })
Vue.use(YmapPlugin, { lang: 'ru_RU', version: '2.1' })
Vue.use(VueYouTubeEmbed, { global: true, componentId: 'youtube' })

import CKEditor from '@ckeditor/ckeditor5-vue'

Vue.use(CKEditor)

Vue.use(VueAxios, axios)

const isProduction = process.env.NODE_ENV === 'production'

if (isProduction && process.env.SENTRY_DSN) {
  Sentry.init({
    dsn: process.env.SENTRY_DSN,
    integrations: [new Integrations.Vue({ Vue, attachProps: true })],
  })
}

// Logger
const options = {
  isEnabled: true,
  logLevel: isProduction ? 'error' : 'debug',
  stringifyArguments: false,
  showLogLevel: true,
  showMethodName: true,
  separator: '|',
  showConsoleColors: true,
}

Vue.use(VueLogger, options)

declare global {
  interface Array<T> {
    swap(x: any, y: any): Array<T>
  }
}

Array.prototype.swap = function (x, y) {
  let b = this[x]
  this[x] = this[y]
  this[y] = b
  return this
}

Vue.mixin(snackbar)
Vue.mixin(user)
Vue.use(VueLocalStorage)
// Or you can specify any other name and use it via this.$ls, this.$whatEverYouWant
Vue.use(VueLocalStorage, {
  name: 'region_content',
  bind: true, //created computed members from your variable declarations
})

Vue.prototype.mdiMap = {
  Вконтакте: 'mdi-vk',
  // Facebook: 'mdi-facebook',
  YouTube: 'mdi-youtube',
  // Twitter: 'mdi-twitter',
  Telegram: 'mdi-telegram',
  Одноклассники: 'mdi-odnoklassniki',
  // Instagram: 'mdi-instagram',
  Дзен: '$vuetify.icons.Дзен',
}

Vue.prototype.eventsMdiMap = {
  Вконтакте: 'mdi-vk',
  // Facebook: 'mdi-facebook',
  YouTube: 'mdi-youtube',
  // Twitter: 'mdi-twitter',
  Telegram: 'mdi-telegram',
  Одноклассники: 'mdi-odnoklassniki',
  // Instagram: 'mdi-instagram',
  Дзен: '$vuetify.icons.Дзен',
}

Vue.prototype.mdiMapColor = {
  Вконтакте: '#4c75a3',
  // Facebook: '#3b5998',
  YouTube: '#c4302b',
  // Twitter: '#1DA1F2',
  Telegram: '#0088cc',
  Одноклассники: '#ed812b',
  // Instagram: '#833ab4',
  Дзен: '#3b5998',
}

new Vue({
  vuetify,
  render: (h) => h(App),
  router,
  store,
}).$mount('#app')
